import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {
    email: '',
    emailCode: '',
    exist: false,
    formpage: '',
    actualTotalPoints: 0,
    username: '',
    asAnnualFee: false,
    asUnsubscription: false,
    authProvider: 0,
    avatar: '',
  },
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, actions) => {
      return {
        ...actions.payload,
      };
    },
    clearUserInfo: (state) => {
      state.userInfo = {
        email: '',
      };
    },
  },
});

export const { setUserInfo, clearUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
